// extracted by mini-css-extract-plugin
module.exports = {"noCategory":"category_noCategory__3Sf-y","categoryTag":"category_categoryTag__2NiFP","addBtn":"category_addBtn__sYokc","shorterWrapper":"category_shorterWrapper__38uiL"};